import { MapClient, } from "indoor-map-lib"
import {
  MAPPEDIN_CLIENT_ID,
  MAPPEDIN_SECRET,
  MAPPEDIN_LOCATION_NAME,
  MAPPEDIN_SEARCH_KEY,
  MAPPEDIN_SEARCH_SECRET,
} from "app/env"

export const mapClient = new MapClient(
  MAPPEDIN_CLIENT_ID,
  MAPPEDIN_SECRET,
  MAPPEDIN_LOCATION_NAME,
  MAPPEDIN_SEARCH_KEY,
  MAPPEDIN_SEARCH_SECRET
)
